import {
  CheckboxStandalone,
  Column,
  Columns,
  Text,
  AccordionItem,
} from 'braid-design-system';
import React, { type ReactNode } from 'react';

interface AccordionItemBaseProps {
  children: ReactNode;
  id: string;
  onSelect: () => void;
  expanded: boolean;
  disabled: boolean;
  isSelected: boolean;
  label: string;
  onToggle: () => void;
}

const size = 'small';

export const QuestionItem = ({
  children,
  id,
  onSelect,
  label,
  expanded,
  disabled,
  isSelected,
  onToggle,
}: AccordionItemBaseProps) => (
  <Columns space="small">
    <Column width="content">
      <Text size={size}>
        <CheckboxStandalone
          id={id}
          aria-label={label}
          name={label}
          size={size}
          disabled={disabled}
          checked={isSelected}
          onChange={onSelect}
        />
      </Text>
    </Column>
    <Column>
      <AccordionItem
        label={label}
        id={id}
        size={size}
        weight={isSelected ? 'medium' : 'regular'}
        tone={disabled ? 'secondary' : undefined}
        expanded={expanded}
        onToggle={onToggle}
      >
        {children}
      </AccordionItem>
    </Column>
  </Columns>
);
